import classNames from 'classnames';

interface MessageProperties {
    title?: string;
    body?: string | string[];
    style?: MessageStyle;
}

export type MessageStyle = "default" | "success" | "caution" | "danger";

const Message = function ({
    title,
    body,
    style = "default"
}: MessageProperties) {
    let messageClasses = classNames({
        "hcs-message": true,
        "hcs-message--success": style == "success",
        "hcs-message--caution": style === "caution",
        "hcs-message--danger": style === "danger"
    });

    return (
        <div className={messageClasses}>
            {title != undefined && (
                <strong className="hcs-message__title">{title}</strong>
            )}
            {body != undefined && typeof body === "string" && (
                <p className="hcs-message__body">{body}</p>
            )}
            {body != undefined && Array.isArray(body) && (
                <div className="hcs-message__body">
                    <ul>
                        {body.map((message: string, index: number) => {
                            return <li key={index}>{message}</li>
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default Message;